import React from 'react'
import { useOutletContext } from 'react-router-dom';
import PeakInteractionTimes from '../../../../components/ClientDashboard/analytics-components/EngagementTiming/PeakInteractionTimes';

const EngagementTimingAnalytics = () => {
  const { dateFilterValue } = useOutletContext();

  return (
    <div>
      <PeakInteractionTimes dateFilterValue={dateFilterValue} />
    </div>
  )
}

export default EngagementTimingAnalytics;